<template>
    <div class="invalid-feedback d-block mt-1" v-if="errors.length > 0">
        <div v-for="(error, index) in errors" :key="index">{{ error }}</div>
    </div>
</template>

<script>
    export default {
        name: 'Error',
        props: {
            error: {
                type: [ Array, String ],
                required: true
            }
        },
        computed: {
            errors: function() {
                return Array.isArray(this.error) ? this.error : [ this.error ]
            }
        }
    }
</script>